<div class="widget theme-light">
  <router-outlet></router-outlet>

  <div class="widget__messages pt-2 pr-2 pl-2">

    <!-- ie11 warning -->
    <app-ie-warning appShowIE11></app-ie-warning>

  </div>
</div>

<div class="widget-shell" *appFlagApplication="environmentApplication.All; platform: environmentPlatform.SDK; mode:'exclude'"></div>